<template>
  <component
    :is="component"
    :class="$style.root">
    <Label :class="$style.label">
      <input
        type="checkbox"
        :class="$style.input"
        @click.stop
        @change="handleInputChange"  
        :checked="checked"
        :disabled="disabled" />
        <span v-if="label" class="ml-2">
          {{label}}
            <Icon 
              v-if="tippy"
              v-tippy
              class="ml-2 cursor-pointer text-dull"
              :content="tippy" 
              name="info-circle"
            />
        </span>
    </Label>
  </component>
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'Checkbox',

  mixins: [ defaultRootComponent('span') ],

  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    tippy: { type: [String, Boolean], default: false},
    label: {
      type: String
    },
    checked: {
      type: Boolean
    },
    color: {
			type: String
    },
    disabled: {
      type: Boolean
    }
  },

  methods: {
    /* v-model support */
    handleInputChange (e) {
      this.$emit('change', e.target.checked)
    }
  },

  computed: {
    iconClass () {
      return [
        this.$style[this.color],
        { [ this.$style.checked ]: this.checked }
      ]
    },

    inputClass () {
      return [ this.$style.input ]
    }
  }

}

</script>

<style module>

  .root {
     @apply
      relative
  }

  .label {
    @apply
      flex
      items-center
  }

  .input {
    @apply
      inline-block
      rounded
      border
      border-dull
      bg-dull-light
      text-primary
      w-4
      h-4
      select-none
      align-middle
      outline-none
      appearance-none
  }

  .input:checked {
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
    border-color: transparent;
    background-color: currentColor;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }

</style>
